/**
 * Dev-only logger. In production (`NODE_ENV === 'production'`) all calls are
 * no-ops, so we avoid leaking debug traces to the browser console and cutting
 * the tiny CPU cost of assembling error strings.
 *
 * `NODE_ENV` is inlined at build time by CRA/webpack — no runtime cost.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logWarn = (...args) => {
  if (isDev) console.warn(...args);
};
